// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3EAba","selects":"Documents_selects__1lo6Y"};